import React, { useCallback, useRef } from 'react';
import styles from './EduCard.module.less';
import classNames from 'classnames';
import { CONTEXT } from '../../config';
import { useHistory } from 'react-router-dom';
import ztBlank from '../../static/zt_blank.png';
import Btn from '../Btn/Btn';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { logging, logPostInfo } from '../../actions/log';
import Toast from '../../components/Toast/Toast';
import { education } from '../../constants/storageKeys';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
/**
 * log:打桩信息
 * tag：right/left学龄截断标签的位置
 * data：展示的数据
 * hasDelete:true/false是都有删除按钮
 * handleDelete：func 点击删除按钮触发的事件
 * type:reading/learning
 *      reading展示课程描述述和观看人数，
 *      learning展示当前课程学习情况，支持可继续学习按钮，点击跳入课程详情页面
 */
export default ({ data, tag = 'right', handleDelete, hasDelete, type = 'reading', log }) => {
  const logInfoData = useSelector(selectLogInfo);
  const history = useHistory();
  const dispatch = useDispatch();
  const el = useRef(null);
  const handleMouseLeave = e => {
    if (
      e &&
      e.currentTarget &&
      e.currentTarget.className &&
      e.currentTarget.className.indexOf(styles.image_mouse_out) < 0
    ) {
      e.currentTarget.className = `${e.currentTarget.className} ${styles.image_mouse_out}`;
      const timer = setTimeout(() => {
        if (el.current && el.current.className.indexOf(styles.image_mouse_out) > -1) {
          el.current.className = classNames(
            styles.edu_card,
            styles.edu_reading_card,
            styles.image_mouse_in,
          );
        }
        clearTimeout(timer);
      }, 500);
    }
  };
  const handleMouseOver = e => {
    if (e && e.currentTarget) {
      el.current = e.currentTarget;
    }
  };
  // studyState 0:进入详情页面，1： 进入详情页面并顺序播放， 2：进入详情页面重头播放
  const handleCard = useCallback((e, param, studyState) => {
    e.stopPropagation();
    // 该课程已下架
    if (param && param.status && param.status === '3') {
      Toast.error({
        content: '该课程已下架，请选择其它课程',
      });
      return;
    }
    if (el.current && el.current.className.indexOf(styles.image_mouse_out) > -1) {
      el.current.className = classNames(styles.edu_card, styles.image_mouse_in);
    }
    dispatch(
      logging({
        category: 'C',
        action: (log && log.action) || 'Edu_Course_Card',
        label: '',
        param2: {
          source: (log && log.source) || logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          courseid: data.courseId,
          age_period: localStorage.getItem(education.EDUSTAGE),
        },
      }),
    );
    dispatch(
      logPostInfo({
        source_p: (log && log.source) || logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );

    history.push(
      `${CONTEXT}/edudetail?courseId=${param.courseId}&bizInfo=${param.bizInfo ||
        '{}'}&studyState=${studyState}`,
    );
  }, []);

  const handleNumber = (num = 0, pay) => {
    const str = pay === 0 ? '人在学' : '人购买';
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(+num)) {
      return num;
    }
    if (+num < 1000) {
      return `${num}${str}`;
    }
    if (+num < 10000) {
      return `${(num / 1000).toFixed(1)}k${str}`;
    }

    return `${(num / 10000).toFixed(1)}w${str}`;
  };

  const handleDeleteOper = par => e => {
    e.stopPropagation();
    e.preventDefault();
    // eslint-disable-next-line no-unused-expressions
    handleDelete && handleDelete(par);
    dispatch(
      logging({
        category: 'C',
        action: 'Edu_Mine_Delete',
        label: '',
        param2: {
          source: (log && log.source) || logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          courseid: data.courseId,
        },
      }),
    );
  };

  const handelPrice = price => {
    if (Number.isNaN(price) || price === 0) {
      return price;
    }
    let formatPrice = (price / 100).toFixed(2);
    formatPrice = formatPrice.replace(/(.00|0)$/g, '');
    return formatPrice;
  };

  return (
    <div
      className={classNames(styles.edu_card, styles.image_mouse_in, styles.edu_reading_card)}
      onMouseLeave={handleMouseLeave}
      onMouseOver={handleMouseOver}
    >
      {data.isTry === 1 && (
        <div
          className={classNames(
            styles.edu_card_tag,
            tag === 'right' ? styles.edu_card_right_tag : styles.edu_card_left_tag,
          )}
        ></div>
      )}
      {hasDelete && (
        <div className={styles.edu_card_delete} onClick={handleDeleteOper(data)}>
          <div alt="" className={styles.edu_card_delete_img}></div>
        </div>
      )}

      <div
        className={styles.edu_card_img_box}
        onClick={e => {
          handleCard(e, data, 0);
        }}
      >
        <img src={data.imgUrl || ztBlank} alt="" className={styles.edu_card_img} />
      </div>
      <div
        className={styles.edu_card_title}
        onClick={e => {
          handleCard(e, data, 0);
        }}
      >
        {data.name}
      </div>
      {type === 'learning' && (
        <>
          <div className={styles.edu_card_info}>
            <div
              className={styles.edu_card_shortDesc}
              onClick={e => {
                handleCard(e, data, 0);
              }}
            >
              {data.learnStatusDesc}
            </div>
          </div>
          <div className={classNames(styles.edu_card_fee)}>
            <div
              className={classNames(styles.edu_card_fee_count)}
              onClick={e => {
                handleCard(e, data, 0);
              }}
            >
              {data.pay === 0 && <span className={styles.free}>免费</span>}
              {data.pay === 1 && (
                <div className={styles.fee_detail}>
                  {(data.price > 0 || data.discountPrice > 0) && (
                    <div className={styles.fee_detail_count}>
                      &yen; {handelPrice(data.discountPrice || data.price)}
                    </div>
                  )}
                  {data.discountPrice !== 0 && data.price > 0 && (
                    <div className={styles.fee_detail_discount}>
                      &yen; {handelPrice(data.price)}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div
              className={classNames(styles.edu_card_watch)}
              onClick={e => {
                handleCard(e, data, data.status === '1' ? 1 : 2);
              }}
            >
              {data.status === '1' && <Btn className={styles.edu_card_study_btn}>继续学习</Btn>}
              {data.status === '2' && <Btn className={styles.edu_card_study_btn}>重新学习</Btn>}
            </div>
          </div>
        </>
      )}
      {type === 'reading' && (
        <>
          <div className={styles.edu_card_info}>
            <div
              className={styles.edu_card_shortDesc}
              onClick={e => {
                handleCard(e, data, 0);
              }}
            >
              {data.shortDesc}
            </div>
          </div>
          <div className={classNames(styles.edu_card_fee)}>
            <div
              className={classNames(styles.edu_card_watch)}
              onClick={e => {
                handleCard(e, data, 0);
              }}
            >
              <span>
                {handleNumber(data.pay === 0 ? data.playerNum || 0 : data.buyNum || 0, data.pay)}
              </span>
            </div>
            <div
              className={classNames(styles.edu_card_fee_count)}
              onClick={e => {
                handleCard(e, data, 0);
              }}
            >
              {data.pay === 0 && <span className={styles.free}>免费</span>}
              {data.pay === 1 && (
                <div className={styles.fee_detail}>
                  {(data.price > 0 || data.discountPrice > 0) && (
                    <div className={styles.fee_detail_count}>
                      &yen; {handelPrice(data.discountPrice || data.price)}
                    </div>
                  )}
                  {data.discountPrice !== 0 && data.price > 0 && (
                    <div className={styles.fee_detail_discount}>
                      &yen; {handelPrice(data.price)}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
